






































































import {Component, Vue, Watch} from 'vue-property-decorator';
import TwoColumnLayout from '@/components/TwoColumnLayout.vue';
import CoreTextInput from '@/components/CoreTextInput.vue';
import CoreSelect from '@/components/CoreSelect';
import AsidePlaceholder from '@/components/AsidePlaceholder.vue';
import CoreCheckbox from '@/components/CoreCheckbox.vue';
import CoreButton from '@/components/CoreButton.vue';
import CoreIcon from '@/components/CoreIcon.vue';
import CircleSpinner from '@/components/CircleSpinner.vue';
import {FormInterface, LeadInterface, StoreGetters, StoreMutations,} from '@/store';
import {Getter, Mutation} from 'vuex-class';
import {Routes} from '@/router';
import LogosSection from '@/components/LogosSection.vue';

@Component({
    components: {
        TwoColumnLayout,
        CoreTextInput,
        CoreSelect,
        AsidePlaceholder,
        CoreCheckbox,
        CoreButton,
        CoreIcon,
        LogosSection,
        CircleSpinner,
    },
})
export default class PersonalInfoPage extends Vue {
    @Getter(StoreGetters.FORM) public form!: FormInterface;
    @Getter(StoreGetters.LEAD) public lead!: LeadInterface;
    @Mutation(StoreMutations.UPDATE_STORE) public updatePersonalInfo;
    @Mutation(StoreMutations.ADD_LEAD_INFO) public updateLeadInfo:
        | undefined
        | ((data: LeadInterface) => void);

    public personalInfoForm: FormInterface = {
        firstName: '',
        lastName: '',
        personalMail: '',
        urlParams: {},
        utm_term: '',
        utm_content: '',
        utm_campaign: '',
        utm_medium: '',
        utm_source: '',
        region: 'EU'
    };

    public formInvalidations = {
        personalMail: false
    };

    public isPendingEmailValidation = false;

    public routes = Routes;

    public get isNextStepButtonDisabled() {
        return !(
            this.personalInfoForm.firstName &&
            this.personalInfoForm.lastName &&
            this.personalInfoForm.personalMail &&
            Object.values(this.formInvalidations).every(isValid => !isValid)
        );
    }

    public mounted() {
        window.scrollTo(0, 0);
    }

    public parseParams = querystring => {
        const params = new URLSearchParams(querystring);
        const obj = {};
        for (const key of params.keys()) {
            if (params.getAll(key).length > 1) {
                obj[key] = params.getAll(key);
            } else {
                obj[key] = params.get(key);
            }
        }
        return obj;
    };

    @Watch('form', {immediate: true, deep: true})
    public update() {
        for (const key in this.form) {
            if (Object.prototype.hasOwnProperty.call(this.form, key)) {
                this.personalInfoForm[key] = this.form[key];
            }
        }
    }

    public async navigate() {
        if (this.isNextStepButtonDisabled) {
            return;
        }
        window['FS']?.consent(true);
        this.$router.push({name: Routes.PLATFORM_SETTINGS});
    }

    public goToTermsAndConditions(e, route) {
        e.stopPropagation();
        e.preventDefault();
        this.$router.push({name: route});
    }

    @Watch('personalInfoForm', {deep: true})
    public updateStore() {
        const {
            firstName,
            lastName,
            personalMail,
            urlParams,
        } = this.personalInfoForm;
        this.updatePersonalInfo({
            firstName,
            lastName,
            personalMail,
            companyMail: personalMail,
            urlParams,
        });
    }

    public async validateFields(field) {
        if (field === 'mail') {
            const email = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            const basicValidation = email.test(
                this.personalInfoForm.personalMail as string
            );

            this.formInvalidations.personalMail = !basicValidation;
        }
    }

    public clearEmailValidation() {
        this.formInvalidations.personalMail = true;
    }
}
